module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_7005.3f534c10.png";